module.exports = __webpack_public_path__ + "img/favicon.a903bc0.png";